module.exports = __webpack_public_path__ + "static/media/ig-vacancy-post.e8b4e5c4.png";